import {createRouter, createWebHistory} from "vue-router";
import store from "../store/index"
import axios from "axios"

const checkLoginStatus = () => {
    if(!store.state.loginStatus){
        let date = new Date();
        if(localStorage.getItem('date')){
            if(date.getTime() / 1000 > localStorage.getItem('date')+60*5){
                axios.get('api/checkLoginStatus', {headers: {"Authorization": `Bearer ${localStorage.getItem('token')}`}}).then(function() {
                    localStorage.setItem('loginStatus','true');
                    localStorage.setItem('date', date.getTime() / 1000);
                    store.state.loginStatus = true;
                }).catch(function() {
                    localStorage.setItem('loginStatus','false');
                    store.state.loginStatus = false;
                });
            }else if(localStorage.getItem('loginStatus')==='true'){
                store.state.loginStatus = true;
            }
        }
        else{
            axios.get('api/checkLoginStatus', {headers: {"Authorization": `Bearer ${localStorage.getItem('token')}`}}).then(function() {
                localStorage.setItem('loginStatus','true');
                localStorage.setItem('date', date.getTime() / 1000);
                store.state.loginStatus = true;
            }).catch(function() {
                localStorage.setItem('loginStatus','false');
                store.state.loginStatus = false;
            });
        }
    }else if(!store.state.preliminaryReview){
        let date = new Date();
        axios.get('api/checkLoginStatus', {headers: {"Authorization": `Bearer ${localStorage.getItem('token')}`}}).then(function() {
            localStorage.setItem('loginStatus','true');
            localStorage.setItem('date', date.getTime() / 1000);
            store.state.preliminaryReview = true;
            store.state.loginStatus = true;
        }).catch(function() {
            localStorage.setItem('loginStatus','false');
            store.state.preliminaryReview = true;
            store.state.loginStatus = false;
        });
    }
};

const userFreeAccess = ({next}) => {
    store.state.accountPage = true;
    if (store.state.preliminaryReview) {
        if (store.state.preliminaryReview && store.state.loginStatus) {
            store.state.userPanelPage= true;
            store.state.authenticationPage = false;
            next();
        } else {
            store.state.userPanelPage= false;
            store.state.authenticationPage = true;
            router.push('/user-signin');
        }
    }else{
        let date = new Date();
        if(localStorage.getItem('date')){
            if(date.getTime() / 1000 > localStorage.getItem('date')+60*5){
                axios.get('api/checkLoginStatus', {headers: {"Authorization": `Bearer ${localStorage.getItem('token')}`}}).then(function() {
                    store.state.userPanelPage= true;
                    store.state.authenticationPage = false;
                    next();
                }).catch(function() {
                    store.state.userPanelPage= false;
                    store.state.authenticationPage = true;
                    router.push('/user-signin');
                });
            }else if(localStorage.getItem('loginStatus')==='true'){
                store.state.userPanelPage= true;
                store.state.authenticationPage = false;
                next();
            }
        }
    }
};

const userLimitedAccess = ({next}) => {
    store.state.accountPage = true;
    if(!store.state.loginStatus && store.state.preliminaryReview){
        store.state.authenticationPage = true;
        store.state.userPanelPage= false;
        next();
    }else if(!store.state.preliminaryReview){
        let date = new Date();
        if(localStorage.getItem('date')){
            if(date.getTime() / 1000 > localStorage.getItem('date')+60*5){
                axios.get('api/checkLoginStatus', {headers: {"Authorization": `Bearer ${localStorage.getItem('token')}`}}).then(function() {
                    store.state.userPanelPage= true;
                    store.state.authenticationPage = false;
                    router.push('/user-panel');
                }).catch(function() {
                    store.state.userPanelPage= false;
                    store.state.authenticationPage = true;
                    next();
                });
            }else if(localStorage.getItem('loginStatus')==='false'){
                store.state.userPanelPage= false;
                store.state.authenticationPage = true;
                next();
            }
        }else{
            store.state.userPanelPage= false;
            store.state.authenticationPage = true;
            next();
        }
    }
};

const publicAccess = ({next}) => {
    store.state.accountPage = false;
    store.state.authenticationPage = false;
    store.state.userPanelPage= false;
            next();
};
const routes = [
    {
        path: "/",
        name: "Home",
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/Home.vue"),
        meta: {
            middleware: publicAccess
        }
    },
    {
        path: "/user-signup",
        name: "UserSignUp",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/UserSignUp.vue"),
        meta: {
            middleware: userLimitedAccess
        }
    },
    {
        path: "/user-signin",
        name: "Login",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/Login.vue"),
        meta: {
            middleware: userLimitedAccess
        }
    },
    {
        path: "/personal-info",
        name: "PersonalInfo",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/PersonalInfo.vue"),
        meta: {
            middleware: userLimitedAccess
        }
    },
    {
        path: "/forget-password",
        name: "ForgetPassword",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/ForgetPassword.vue"),
        meta: {
            middleware: userLimitedAccess
        }
    },

    {
        path: "/password-recovery/:token",
        name: "PasswordRecovery",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/PasswordRecovery.vue"),
        meta: {
            middleware: userLimitedAccess
        }
    },
    {
        path: "/rules",
        name: "Rules",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/Rules.vue"),
        meta: {
            middleware: publicAccess
        }
    },
    {
        path: "/application-page",
        name: "ApplicationPage",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/ApplicationPage.vue"),
        meta: {
            middleware: publicAccess
        }
    },
    {
        path: "/about-us",
        name: "AboutUs",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/AboutUs.vue"),
        meta: {
            middleware: publicAccess
        }
    },
    {
        path: "/faq",
        name: "Faq",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/Faq.vue"),
        meta: {
            middleware: publicAccess
        }
    },
    {
        path: "/category-view/:slug",
        name: "CategoryView",
        // route lev-el code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/CategoryView.vue"),
        meta: {
            middleware: publicAccess
        }
    },
    {
        path: "/article-view/:slug",
        alias: ['/:slug'],
        name: "ArticleView",
        // route lev-el code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/ArticleView.vue"),
        meta: {
            middleware: publicAccess
        }
    },
    {
        path: "/related-articles/:slug",
        name: "RelatedArticles",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/RelatedArticles.vue"),
        meta: {
            middleware: publicAccess
        }
    },
    {
        path: "/search-results/:requested",
        name: "SearchResults",
        // route lev-el code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/SearchResults.vue"),
        meta: {
            middleware: publicAccess
        }
    },
    {
        path: "/author-page/:username",
        name: "AuthorPage",
        // route lev-el code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ "../views/AuthorPage.vue"),
        meta: {
            middleware: publicAccess
        }
    },
    {
        path: "/user-panel",
        name: "UserPanel",
        // route lev-el code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ "../views/UserPanel.vue"),
        meta: {
            middleware: userFreeAccess
        }
        ,
        children: [
            {
                path: '',
                name: 'UserHome',
                component: () => import("../views/UserPanel/UserHome.vue"),
                meta: {
                    middleware: userFreeAccess
                }
            },
            {
                path: 'edit-personal-infos',
                name: 'EditPersonalInfos',
                component: () => import("../views/UserPanel/EditPersonalInfos.vue"),
                meta: {
                    middleware: userFreeAccess
                }
            },
            {
                path: 'saved-articles',
                name: 'SavedArticles',
                component: () => import("../views/UserPanel/SavedArticles.vue"),
                meta: {
                    middleware: userFreeAccess
                }
            },
            {
                path: "conversation-with-experts/:mode",
                name: 'ConversationWithExperts',
                component: () => import("../views/UserPanel/ConversationWithExperts.vue"),
                meta: {
                    middleware: userFreeAccess
                }
            },
            {
                path: 'user-bills',
                name: 'UserBills',
                component: () => import("../views/UserPanel/UserBills.vue"),
                meta: {
                    middleware: userFreeAccess
                }
            },
            {
                path: 'user-documents',
                name: 'UserDocuments',
                component: () => import("../views/UserPanel/UserDocuments.vue"),
                meta: {
                    middleware: userFreeAccess
                }
            },
            {
                path: 'advanced-search',
                name: 'AdvancedSearch',
                component: () => import("../views/UserPanel/AdvancedSearch.vue"),
                meta: {
                    middleware: userFreeAccess
                }
            },
            {
                path: 'logout',
                name: 'Logout',
                component: () => import("../views/UserPanel/Logout.vue"),
                meta: {
                    middleware: userFreeAccess
                }
            },
        ]
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
        checkLoginStatus();
        return {top: 0}
    },
});

router.beforeEach((to, from, next) => {
    if (to.meta.middleware) {
        checkLoginStatus();
        to.meta.middleware({to, from, next});
    }else {
        next();
    }
});

export default router;
